/**
 * The public layout document (contracts/ui-api.md "New run"; FR-008, C-004;
 * U.3, P.4). Typed only with the members the UI reads: `records_csv`,
 * `records_xlsx` and `limits.xlsx` are never rendered, so they are not here.
 * The Path B byte limit is `admission_cap` times 2,048 (DM-01M39TVF94JS6PXWP3T94RNCN0).
 */
import { InvalidIdError, api } from '../api'

export type LayoutVersion = 'v1'
const LAYOUT_VERSIONS: readonly string[] = ['v1']

export interface LayoutDocument {
  limits: {
    admission_cap: number
    bytes: number
    types: string[]
  }
}

export async function getLayout(version: LayoutVersion): Promise<LayoutDocument> {
  if (!LAYOUT_VERSIONS.includes(version)) throw new InvalidIdError('layout version')
  return api<LayoutDocument>(`/public/layout/${encodeURIComponent(version)}`)
}
